<template>
  <div class="card3">
    <div class="card3_img" @click.stop="goDetail">
      <div class="bigBg" :style="{backgroundImage: 'url(' + item.coverImageList[0].url + ')'}"></div>
      <div class="small_bg_box">
        <div class="smallBg" :style="{backgroundImage: 'url(' + item.coverImageList[1].url + ')'}"></div>
        <div class="smallBg" :style="{backgroundImage: 'url(' + item.coverImageList[2].url + ')'}"></div>
      </div>
    </div>
    <div class="cardInfo">
      <div class="title two_line" @click.stop="goDetail">
        <span style="color: #008BFF;" v-if="item.zhuanti">专题 | </span>
        <span>{{ item.title }}</span>
      </div>
      <div class="otherInfo flex_center">
        <div class="sourceInfo flex_row flex_center">
          <div class="logo_box" v-if="userInfo.logo !== ''">
            <img class="sourceImg" :src="userInfo.logo" alt="">
            <img class="v_icon" :src="item.xinhua.vimgUrl" alt="" v-if="item.xinhua && item.xinhua.vflag">
          </div>
          <div class="sourceName">{{ userInfo.name }}</div>
          <div class="sourceName" v-if="item.commentNum">{{ item.commentNum }}评</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card3',
  props: [ 'item' ],
  computed: {
    // 用户信息
    userInfo () {
      let item = this.item
      let userInfo = {
        logo: '',
        name: item.sourceName || ''
      }
      if ( item.cuser ) {
        userInfo.logo = item.cuser.logo
        userInfo.name = item.cuser.name
        userInfo.uuid = item.cuser.cuserThirdId
      }
      if ( item.xinhua ) {
        userInfo.logo = item.xinhua.xinhuaCover
        userInfo.name = item.xinhua.xinHuaName
        userInfo.uuid = item.xinhua.xinHuaUuid
      }
      return userInfo
    }
  },
  methods: {
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card3 {
  width: 100%;
  height: 224px;
  background-image: url("../../../assets/images1/recommend/showType3_bg.png");
  background-size: cover;
  padding: 5px 5px 12px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.card3_img {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.bigBg {
  flex: 1;
  height: 129px;
  background-size: cover;
  background-position: 50%;
  border-radius: 12px;
  margin-right: 4px;
}

.small_bg_box {
  height: 129px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.smallBg {
  width: 106px;
  height: 62px;
  background-size: cover;
  background-position: 50%;
  border-radius: 12px;
}
</style>

<style scoped>
.cardInfo {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.title {
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  margin-bottom: 8px;
}

.otherInfo {
  padding: 0 8px 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.sourceInfo {
  font-size: 12px;
  line-height: 17px;
  color: rgba(255, 255, 255, .65);
}

.sourceImg {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 10px;
  border-radius: 50%;
  object-fit: cover;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 10px;
  position: relative;
}

.v_icon {
  width: 8px;
  height: 8px;
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sourceName {
  margin-right: 8px;
}
</style>